(() => {
  const loadVideo = (video) => {
    if (!video || video.dataset.siLazyVideoLoaded === 'true') return;

    video.querySelectorAll('[data-src]').forEach((source) => {
      source.setAttribute('src', source.dataset.src);
      source.removeAttribute('data-src');
    });

    video.dataset.siLazyVideoLoaded = 'true';
    video.load();

    if (video.dataset.siAutoplay === 'true') {
      const playPromise = video.play();
      if (playPromise !== undefined) playPromise.catch(() => {});
    }
  };

  const init = () => {
    const videos = document.querySelectorAll('[data-si-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '500px 0px' });

    videos.forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
